import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Text.scss';

const propTypes = {
    animate: PropTypes.oneOf([null, 'in', 'out']),
    children: PropTypes.node,
    className: PropTypes.string,
    component: PropTypes.string,
    background: PropTypes.oneOf([null, 'dark', 'light']),
    icon: PropTypes.node,
    iconSmall: PropTypes.bool,
    alignIcon: PropTypes.oneOf(['top', 'center', 'bottom']),
};

const defaultProps = {
    animate: null,
    children: null,
    className: null,
    component: 'p',
    background: null,
    icon: false,
    iconSmall: true,
    alignIcon: 'center',
};

const Text = ({
 animate, children, className, component, icon, iconSmall, alignIcon, ...props
}) => {
    const classes = classnames({
        [`animate-${animate}`]: animate !== null,
        [className]: !!className,
        'Text--has-icon': !!icon,
        'Text--icon-small': !!iconSmall,
        [`Text--align-icon-${alignIcon}`]: !!alignIcon,
    });

    const Icon = ({ ...iconProps }) => React.cloneElement(icon, { ...iconProps });

    const Component = component;
    const componentProps = {
        ...props,
    };

    let content = (
        <>
            {icon && <Icon className="Text__icon" />}
            {children}
        </>
    );

    if (component === 'h4') {
        content = (
            <span className="Text__outer">
                <span className="Text__inner">
                    {icon && <Icon className="Text__icon" />}
                    {children}
                </span>
            </span>
        );
    }

    return (
        <Component className={classes} {...componentProps}>
            {content}
        </Component>
    );
};

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export default Text;
